module.exports = __webpack_public_path__ + "static/media/filter-black.fa652caf.svg";